import Store from 'redux/store';
import {
  ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_SUCCESS,
  FETCH_SIMPLE_WISHLIST,
  FETCH_SIMPLE_WISHLIST_FAIL,
  FETCH_SIMPLE_WISHLIST_SUCCESS,
  REMOVE_FROM_WISHLIST,
  REMOVE_FROM_WISHLIST_SUCCESS,
} from 'redux/Reducers/SimpleWishlist/SimpleWishlistReducer';

import {
  FETCH_WISHLIST,
  FETCH_WISHLIST_FAIL,
  FETCH_WISHLIST_SUCCESS,
} from 'redux/Reducers/SimpleWishlist/Wishlist';


import { cloudloyalty } from '../clients';

/* eslint-disable */
export const FetchWishlist = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_WISHLIST });
  cloudloyalty(User).get('/v1/participants/me/wishlist').then((response) => {
    Store.dispatch({
      type: FETCH_WISHLIST_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_WISHLIST_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchSimpleWishlist = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_SIMPLE_WISHLIST });
  if (User && User?.access_token) {
    cloudloyalty(User).get('/v1/participants/me/simplewishlist').then((response) => {
      Store.dispatch({
        type: FETCH_SIMPLE_WISHLIST_SUCCESS,
        payload: {
          ...response,
        },
      });
    }).catch((e) => {
      Store.dispatch({
        type: FETCH_SIMPLE_WISHLIST_FAIL, error: e,
      });
    })
      .finally(() => {
        finallyCallback();
      });
  } else {
    Store.dispatch({
      type: FETCH_SIMPLE_WISHLIST_FAIL, error: '',
    });
  }
};

export const AddWishlist = async (User, finallyCallback = () => {}, { sku, callback }) => {
  Store.dispatch({ type: ADD_TO_WISHLIST });
  cloudloyalty(User).put(`/v1/participants/me/wishlist/${sku}/add`, {}).then((response) => {
    Store.dispatch({
      type: ADD_TO_WISHLIST_SUCCESS,
      payload: {
        products: [
          sku
        ]
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: `${ADD_TO_WISHLIST}_FAIL`, error: e,
    });
  })
    .finally(() => {
      if (callback) callback()
      finallyCallback();
    });
};

export const RemoveWishlist = async (User, finallyCallback = () => {}, { sku, callback }) => {
  Store.dispatch({ type: REMOVE_FROM_WISHLIST });
  cloudloyalty(User).delete(`/v1/participants/me/wishlist/${sku}/remove`, {}).then((response) => {
    Store.dispatch({
      type: REMOVE_FROM_WISHLIST_SUCCESS,
      payload: {
        sku: sku
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: `${REMOVE_FROM_WISHLIST}_FAIL`, error: e,
    });
  })
    .finally(() => {
      if (callback) callback()
      finallyCallback();
    });
};
